export * from './lib/remove-accent.module';
